export enum Route {
    ProductSearch = "/products/search",
    FilterConfiguration = "/products/filter-configuration"
}